import { render, staticRenderFns } from "./DynamicQuestionnaireForm.vue?vue&type=template&id=dfbfc198&scoped=true&"
import script from "./DynamicQuestionnaireForm.vue?vue&type=script&lang=js&"
export * from "./DynamicQuestionnaireForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicQuestionnaireForm.vue?vue&type=style&index=0&id=dfbfc198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbfc198",
  null
  
)

export default component.exports